import { c as _c } from "react/compiler-runtime";
import { alpha, Box, useTheme } from "@mui/material";
import React from "react";
import type { ArrayData, ArrayDataState, ArrayItemData } from "#/entities/dataStructures/array/model/arraySlice";
import { StructureDisplayLabel } from "#/entities/dataStructures/array/ui/StructureDisplayLabel";
import { MatrixRow } from "#/entities/dataStructures/matrix/ui/MatrixRow";
type MatrixStructureViewProps = {
  data: ArrayData;
  arrayState: ArrayDataState;
};
export const MatrixStructureView: React.FC<MatrixStructureViewProps> = t0 => {
  const $ = _c(65);
  const {
    data,
    arrayState
  } = t0;
  const theme = useTheme();
  let t1;
  if ($[0] !== theme.palette.primary.light) {
    t1 = alpha(theme.palette.primary.light, 0.3);
    $[0] = theme.palette.primary.light;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const borderColor = `1px solid ${t1}`;
  const lastNode = data.nodes.entities[String(data.nodes.ids.at(-1))];
  const lastIndex = lastNode?.index ?? 0;
  let T0;
  let T1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[2] !== arrayState || $[3] !== borderColor || $[4] !== data.colHeaders || $[5] !== data.colorMap || $[6] !== data.displayLabel || $[7] !== data.nodes.entities || $[8] !== data.nodes.ids || $[9] !== data.rowHeaders || $[10] !== lastIndex || $[11] !== theme.palette.action.active || $[12] !== theme.palette.primary.light || $[13] !== theme.palette.text.secondary) {
    const dataArray = data.nodes.ids.map(id => data.nodes.entities[id]);
    const items = new Array(lastIndex + 1);
    dataArray.forEach(node => {
      if (node) {
        items[node.index] = node;
      }
    });
    T1 = Box;
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = {
        overflow: "hidden"
      };
      $[22] = t6;
    } else {
      t6 = $[22];
    }
    if ($[23] !== data.displayLabel) {
      t7 = data.displayLabel ? <StructureDisplayLabel label={data.displayLabel} /> : null;
      $[23] = data.displayLabel;
      $[24] = t7;
    } else {
      t7 = $[24];
    }
    T0 = Box;
    t3 = "table";
    const t8 = theme.palette.text.secondary;
    let t9;
    if ($[25] !== theme.palette.action.active) {
      t9 = alpha(theme.palette.action.active, 0.01);
      $[25] = theme.palette.action.active;
      $[26] = t9;
    } else {
      t9 = $[26];
    }
    let t10;
    if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
      t10 = {
        borderRightWidth: 2
      };
      $[27] = t10;
    } else {
      t10 = $[27];
    }
    let t11;
    if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
      t11 = {
        borderBottomWidth: 2,
        "&:first-of-type": {
          borderRightWidth: 2
        }
      };
      $[28] = t11;
    } else {
      t11 = $[28];
    }
    let t12;
    if ($[29] !== borderColor || $[30] !== t9 || $[31] !== theme.palette.text.secondary) {
      t12 = {
        padding: 1,
        textAlign: "center",
        borderBottom: borderColor,
        borderRight: borderColor,
        fontWeight: "light",
        fontSize: "12px",
        lineHeight: "12px",
        color: t8,
        backgroundColor: t9,
        "&[scope='row']": t10,
        "&[scope='col']": t11
      };
      $[29] = borderColor;
      $[30] = t9;
      $[31] = theme.palette.text.secondary;
      $[32] = t12;
    } else {
      t12 = $[32];
    }
    let t13;
    if ($[33] !== theme.palette.primary.light) {
      t13 = alpha(theme.palette.primary.light, 0.032);
      $[33] = theme.palette.primary.light;
      $[34] = t13;
    } else {
      t13 = $[34];
    }
    let t14;
    if ($[35] !== t13) {
      t14 = {
        content: "\"\"",
        position: "absolute",
        top: "-5000px",
        left: 0,
        width: "100%",
        height: "10000px",
        backgroundColor: t13
      };
      $[35] = t13;
      $[36] = t14;
    } else {
      t14 = $[36];
    }
    let t15;
    if ($[37] !== borderColor || $[38] !== t14) {
      t15 = {
        position: "relative",
        padding: 0,
        border: borderColor,
        "&:hover::after": t14
      };
      $[37] = borderColor;
      $[38] = t14;
      $[39] = t15;
    } else {
      t15 = $[39];
    }
    if ($[40] !== borderColor || $[41] !== t12 || $[42] !== t15) {
      t4 = {
        width: "fit-content",
        borderCollapse: "collapse",
        borderSpacing: 0,
        border: borderColor,
        borderRadius: "4px",
        boxSizing: "border-box",
        th: t12,
        td: t15
      };
      $[40] = borderColor;
      $[41] = t12;
      $[42] = t15;
      $[43] = t4;
    } else {
      t4 = $[43];
    }
    let t16;
    if ($[44] !== data.colHeaders) {
      t16 = data.colHeaders ? <><th scope="col" />{data.colHeaders.map(_temp)}</> : null;
      $[44] = data.colHeaders;
      $[45] = t16;
    } else {
      t16 = $[45];
    }
    if ($[46] !== t16) {
      t5 = <thead><tr>{t16}</tr></thead>;
      $[46] = t16;
      $[47] = t5;
    } else {
      t5 = $[47];
    }
    let t17;
    if ($[48] !== arrayState || $[49] !== data.colorMap || $[50] !== data.rowHeaders) {
      t17 = (node_0, index_0) => {
        if (!node_0) {
          return null;
        }
        const name = node_0.childName ?? "";
        const nodeData = arrayState[name];
        const header = data.rowHeaders?.[node_0.index];
        if (nodeData) {
          return <MatrixRow key={name} header={header} data={nodeData} parentColorMap={data.colorMap} />;
        }
        return <Box key={index_0} component="tr" sx={{
          height: 43
        }}>{header ? <th scope="row">{header}</th> : null}</Box>;
      };
      $[48] = arrayState;
      $[49] = data.colorMap;
      $[50] = data.rowHeaders;
      $[51] = t17;
    } else {
      t17 = $[51];
    }
    t2 = items.map(t17);
    $[2] = arrayState;
    $[3] = borderColor;
    $[4] = data.colHeaders;
    $[5] = data.colorMap;
    $[6] = data.displayLabel;
    $[7] = data.nodes.entities;
    $[8] = data.nodes.ids;
    $[9] = data.rowHeaders;
    $[10] = lastIndex;
    $[11] = theme.palette.action.active;
    $[12] = theme.palette.primary.light;
    $[13] = theme.palette.text.secondary;
    $[14] = T0;
    $[15] = T1;
    $[16] = t2;
    $[17] = t3;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
  } else {
    T0 = $[14];
    T1 = $[15];
    t2 = $[16];
    t3 = $[17];
    t4 = $[18];
    t5 = $[19];
    t6 = $[20];
    t7 = $[21];
  }
  let t8;
  if ($[52] !== t2) {
    t8 = <tbody>{t2}</tbody>;
    $[52] = t2;
    $[53] = t8;
  } else {
    t8 = $[53];
  }
  let t9;
  if ($[54] !== T0 || $[55] !== t3 || $[56] !== t4 || $[57] !== t5 || $[58] !== t8) {
    t9 = <T0 component={t3} sx={t4}>{t5}{t8}</T0>;
    $[54] = T0;
    $[55] = t3;
    $[56] = t4;
    $[57] = t5;
    $[58] = t8;
    $[59] = t9;
  } else {
    t9 = $[59];
  }
  let t10;
  if ($[60] !== T1 || $[61] !== t6 || $[62] !== t7 || $[63] !== t9) {
    t10 = <T1 sx={t6}>{t7}{t9}</T1>;
    $[60] = T1;
    $[61] = t6;
    $[62] = t7;
    $[63] = t9;
    $[64] = t10;
  } else {
    t10 = $[64];
  }
  return t10;
};
function _temp(value, index) {
  return <th key={index} scope="col">{value}</th>;
}